﻿namespace eXpress.core {
	export function WatchLogin() {
		const emptyGuid = '00000000-0000-0000-0000-000000000000';
		let timer = -1;
		let startingAccId;
		let accountType;
		let dialog: eXpress.core.StyleguideViewPopup;
		let openDialog = false;

		const start = () => {
			if (timer < 0) {
				startingAccId = eXpress.utils.getCookie("accid");
				accountType = eXpress.utils.getCookie("acctype");
				// @ts-ignore
				timer = setInterval(() => { run(); }, 1500);
			}
		};

		const run = () => {
			const currentAccountId = eXpress.utils.getCookie("accid");
			if (currentAccountId === startingAccId || openDialog) return; // return nothing to report

			// User logged out in another tab
			if (!currentAccountId || currentAccountId === emptyGuid) {
				alert('Label.LoginManager.LogoutInDifferentTab', 'Label.LoginManager.LogoutInDifferentTab.PopupTitle');
				clearTimeout(timer);
				return;
			}

			// User is logged in with a different account.
			if (accountType === 'full') {
				// We used to be a FULL, now a different account -> Impossible
				alert('Label.LoginManager.DifferentAccount', 'Label.LoginManager.DifferentAccount.PopupTitle');
				clearTimeout(timer);
				return;
			}

			// TEMP got merged into FULL -> OK
			// Different FULL -> NOK
			// We need a webservice call for this ...
			openDialog = true; // set this in case that the api call takese longer then the interval and it does it again
			$.ajax(
				{
					url: "/api/v1/AccountService.svc/json/CheckAccountValidity",
					type: "POST",
					contentType: 'application/json',
					data: JSON.stringify({ oldAccountId: startingAccId, newAccountId: currentAccountId })
				}
			).then(res => {
				openDialog = false;
				if (!res) {
					alert('Label.LoginManager.DifferentAccount', 'Label.LoginManager.DifferentAccount.PopupTitle');
					return;
				}

				startingAccId = currentAccountId;
			});
		};

		const alert = (key: string, title: string) => {
			if (openDialog) return;
			openDialog = true;
			const dialogEl = html.querySelector<HTMLElement>(document, '.has-open-dialog', false);
			if (dialogEl && dialog)
				dialog.close(null);

			eXpress.core.StyleguideViewPopup.createDialogAsync(
				{ view: 'DialogUX', dialogId: "information", forceRefresh: true },
				{ question: key, title, okmnemonic: 'Label.OkButtonText', cancelmnemonic: null, replacements: null })
				.then($popup => {
					dialog = new eXpress.core.StyleguideViewPopup($popup, { closeEvent: closeEventPopup, closeOnClickOutsidePopup: true });
					const okbutton = html.querySelector<HTMLElement>($popup[0], '.technical-remove-confirmation-yes-button', false);
					if (okbutton) okbutton.addEventListener('click', () => closeEventPopup());
					dialog.openAsync();
				});
		};

		const closeEventPopup = () => {
			location.reload();
			openDialog = false;
		};

		const cancelEvent = () => {
			openDialog = true; // so that it does not open while we try to cancel
			clearTimeout(timer);
		};

		const stop = () => {
			if (timer > 0)
				clearTimeout(timer);
		};

		return {
			start,
			cancelEvent,
			stop
		};
	}
}
